// tslint:disable: completed-docs
import {
    RootState,
    connect,
    injectReducer,
    injectSaga,
} from '@vfde-sails/core';
import {
    ADDITIONAL_CMS_SITE_STRUCTURE_PERSONAL_DETAILS,
    ERROR_PAGE,
    HEADER_IMAGE,
    NAMESPACE,
} from './constant';
import { createStructuredSelector } from 'reselect';
import {
    selectCaptchaUrl,
    selectCaptchaHash,
    selectCaptchaMediaType,
    selectCustomerInformation,
    selectError,
} from './selector';
import reducer from './reducer';
import saga from './saga';
import {
    ActionDispatchers,
    actionDispatchers,
} from './action';
import { createCaptcha } from './helper/createCaptcha.helper';
import { mountAndValidateFormElements } from './helper/mountFormElements.helper';
import { fillResultTable } from './helper/fillResultTable.helper';
import { captchaValidator } from './helper/validators.helper';
import { IStateCancellationForm } from './interface';
import { trackPageView } from './helper/tracking.helper';

/**
 * CancellationForm function
 */
function cancellationForm (state: IStateCancellationForm, actions: ActionDispatchers) {
    injectReducer(NAMESPACE, reducer);
    injectSaga(NAMESPACE, saga);

    const formElements = mountAndValidateFormElements(actions.getCaptcha);
    actions.getCaptcha(HEADER_IMAGE);
    trackPageView(ADDITIONAL_CMS_SITE_STRUCTURE_PERSONAL_DETAILS);

    return {
        /**
         * This function is called on first load and everytime the store changes.
         */
        getDerivedStateFromProps (newState: IStateCancellationForm, oldState: IStateCancellationForm) {
            if (
                newState !== oldState
                && newState.captchaMediaType
                && newState.captchaUrl
                && newState.captchaHash
                && newState.captchaUrl !== oldState.captchaUrl
            ) {
                if (
                    formElements
                    && formElements.playBtn
                    && formElements.sendBtn
                    && formElements.refreshBtn
                ) {
                    createCaptcha(newState.captchaMediaType, newState.captchaUrl, newState.captchaHash, actions, formElements);
                }
            }

            if (newState.customerInformation !== oldState.customerInformation && newState.customerInformation) {
                fillResultTable(newState.customerInformation);
            }

            if (newState.error !== oldState.error && newState.error) {
                switch (newState.error.status) {
                    case 400: {
                        formElements && formElements.captchaInput && captchaValidator(formElements.captchaInput);
                        break;
                    }
                    default: {
                        window.location.href = ERROR_PAGE;
                        break;
                    }
                }
            }
        },
    };
}

const mapStateToProps = createStructuredSelector<RootState<IStateCancellationForm>, IStateCancellationForm>({
    customerInformation: selectCustomerInformation(),
    error: selectError(),
    captchaUrl: selectCaptchaUrl(),
    captchaMediaType: selectCaptchaMediaType(),
    captchaHash: selectCaptchaHash(),
});

const mountCancellationFormContainer = connect(mapStateToProps, actionDispatchers)(cancellationForm);
export default mountCancellationFormContainer;
